export const contentTableConfig = {
  title: '业务员工作量统计',
  propList: [
    { prop: 'usedBy', label: '使用人', minWidth: '120', isFixed: true },
    { prop: 'parentDept', label: '组', minWidth: '120', isFixed: true },
    { prop: 'deptName', label: '部门', minWidth: '120', isFixed: true },
    { prop: 'num', label: '账号数量', minWidth: '120', sortable: true },
    {
      prop: 'customerCountAll',
      label: '总客户数',
      minWidth: '120',
      sortable: true
    },
    { prop: 'isVoice', label: '一天30分钟且十通1分钟', minWidth: '120' },
    { prop: 'voiceTotal', label: '总时长', minWidth: '120', sortable: true },
    { prop: 'significand', label: '有效次数', minWidth: '120', sortable: true },
    {
      prop: 'baoJiaNum1',
      label: '518报价客户数量/互动达标数',
      minWidth: '120',
      slotName: 'baoJiaNum1',
      sortable: true
    },
    {
      prop: 'jiHuoNum1arrNum',
      label: '518激活客户数量',
      minWidth: '120',
      sortable: true
    },
    {
      prop: 'baoJiaNum2',
      label: '投教报价客户数量/互动达标数',
      minWidth: '120',
      slotName: 'baoJiaNum2'
    },
    {
      prop: 'jiHuoNum2arrNum',
      label: '投教激活客户数量',
      minWidth: '120',
      sortable: true
    },
    {
      prop: 'fuWuNum',
      label: '投教服务介绍客户数量/互动达标数',
      minWidth: '120',
      slotName: 'fuWuNum'
    },
    {
      prop: 'jingPoNumArrNum',
      label: '投教紧迫性客户数量',
      minWidth: '120',
      sortable: true
    },
    {
      prop: 'sendTotalAll',
      label: '发送总量',
      minWidth: '120',
      sortable: true
    },
    {
      prop: 'sendCountAll',
      label: '消息接收客户数',
      minWidth: '120',
      sortable: true
    },
    {
      prop: 'replyTotalAll',
      label: '回复消息数',
      minWidth: '120',
      sortable: true
    },
    {
      prop: 'replyCountAll',
      label: '回复客户数',
      minWidth: '120',
      sortable: true
    },
    {
      prop: 'replyCountAllNew',
      label: '新资源回复客户数',
      minWidth: '120',
      sortable: true
    },
    {
      prop: 'replyCountAllOld',
      label: '老资源回复客户数',
      minWidth: '120',
      sortable: true
    },
    {
      prop: 'avgSend',
      label: '客户平均接收条数',
      minWidth: '120',
      sortable: true,
      sortMethod: function (a: any, b: any) {
        return parseFloat(a.avgSend) - parseFloat(b.avgSend)
      }
    },
    {
      prop: 'avgReply',
      label: '客户平均回复条数',
      minWidth: '120',
      sortable: true,
      sortMethod: function (a: any, b: any) {
        return parseFloat(a.avgReply) - parseFloat(b.avgReply)
      }
    },
    {
      prop: 'replyRate',
      label: '消息响应率',
      minWidth: '120',
      sortable: true,
      sortMethod: function (a: any, b: any) {
        return (
          parseFloat(a.replyRate.replace('%', '')) / 100 -
          parseFloat(b.replyRate.replace('%', '')) / 100
        )
      }
    },
    {
      prop: 'per',
      label: '回复率',
      minWidth: '120',
      sortable: true,
      sortMethod: function (a: any, b: any) {
        return (
          parseFloat(a.per.replace('%', '')) / 100 -
          parseFloat(b.per.replace('%', '')) / 100
        )
      }
    },
    {
      prop: 'zhiBoNum1',
      label: '发送录播数量',
      minWidth: '120',
      sortable: true
    },
    {
      prop: 'zhiBoNum2',
      label: '发送升级直播数量',
      minWidth: '120',
      sortable: true
    },
    {
      prop: 'reply10wCountAll',
      label: '新资源10w数量',
      minWidth: '120',
      sortable: true
    },
    {
      prop: 'replyCountAllPer',
      label: '新资源10w百分比',
      minWidth: '120',
      sortable: true,
      sortMethod: function (a: any, b: any) {
        return (
          parseFloat(a.replyCountAllPer.replace('%', '')) / 100 -
          parseFloat(b.replyCountAllPer.replace('%', '')) / 100
        )
      }
    },
    {
      prop: 'meetingNum',
      label: '发送腾讯会议数量',
      minWidth: '120',
      sortable: true
    }
  ],
  rules: [],
  showIndexColumn: false,
  showSelectColumn: false
}
